export default "__VITE_ASSET__BcKMz2mV__"